import config, { serviceMapCloudOsPartial } from '@Apis/config.api';
import {
	Environments,
	getApiEnvironment,
	getService,
	ServiceMap,
} from '@innovyze/stylovyze';
import { AccountTransitionCache } from '@Utils/cloudos/AccountTransitionCache';
import { InternalAxiosRequestConfig } from 'axios';

type SecondLevelKeys<T extends Record<string, unknown>> = keyof {
	[K in keyof T]: T[K];
}[keyof T];

export type ApiServiceNames = SecondLevelKeys<ServiceMap>;

export const getServiceCloudOS = (
	service: ApiServiceNames,
	environmentOverride?: keyof typeof Environments,
) => {
	const serviceMapCloudOs = serviceMapCloudOsPartial();
	return getService(service, serviceMapCloudOs, environmentOverride);
};

type BuildBaseUrlRequest = {
	serviceName: ApiServiceNames;
	apiEnv: ReturnType<typeof getApiEnvironment>;
	cloudOs: boolean;
};
export const buildBaseUrl = (params: BuildBaseUrlRequest): string => {
	const { serviceName, cloudOs, apiEnv } = params;
	return cloudOs
		? getServiceCloudOS(serviceName, apiEnv)
		: getService(serviceName, config, apiEnv);
};

export const createCloudOsUrlInterceptor = (serviceName: ApiServiceNames) => {
	const interceptorFn = async (currentConfig: InternalAxiosRequestConfig) => {
		const accChecker = AccountTransitionCache.getInstance();
		const apiEnv = getApiEnvironment();
		const cloudOs = await accChecker.isTransitionAccount();
		currentConfig.baseURL = buildBaseUrl({ serviceName, apiEnv, cloudOs });
		return currentConfig;
	};
	return interceptorFn;
};
